import { Box, Grid, Tab, Tabs } from '@hopskipdrive/react-components';
import { colorPalette, colorTokens, variables } from '@rideiq/shared/components/variables';
import styled from 'styled-components';

export const RideOverviewOuterContainer = styled(Box)`
  &.MuiBox-root {
    ${variables.mediaQuery.greaterThan('desktop')`
      position: fixed;
      width: 46vw;
      bottom: 10px;
      margin: 0 10px;
      max-height: 90%;
      overflow-y: scroll;
    `}
  }
`;
export const Container = styled.div`
  position: relative;

  ${variables.mediaQuery.lessThan('desktop')`
      margin-bottom: 16px;
    `}
`;
export const RideOverviewContainer = styled(Box)`
  background-color: ${colorTokens.background.default};
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.25);
  width: 100%;
  border-radius: 8px;
  padding: 20px 30px;

  ${variables.mediaQuery.lessThan('desktop')`
       box-shadow: none;
       border-radius: 0px;
    `}

  .MuiGrid-item:last-of-type .MuiBox-root {
    border-right: 0;
  }
`;

export const RideOverviewTabs = styled(Tabs)`
  padding: 0 !important;
  margin-bottom: 12px;

  ${variables.mediaQuery.lessThan('desktop')`
      margin-bottom: 0;
  `}
`;

export const RideOverviewTab = styled(Tab)`
  font-weight: 700;
  text-transform: none;
  cursor: pointer;

  &.MuiTab-textColorPrimary.Mui-disabled {
    opacity: 1;
  }
`;

export const CornerWrapper = styled.div`
  position: absolute;
  top: 1rem;
  right: 1rem;
  color: ${colorPalette.neutral70};
  &:hover {
    cursor: pointer;
  }
`;

export const ExpandableContainer = styled.div<{ height: string }>`
  height: ${({ height }) => height};
  width: 100%;
`;
export const RideOverviewContent = styled(Grid)<{ height: string }>`
  height: ${({ height }) => height};
  overflow-y: auto;

  ${variables.mediaQuery.lessThan('desktop')`
       overflow: hidden;
    `}
`;
